export { default as Product } from './Product'
export { default as ProductItem } from './ProductItem'
export { default as ProductsList } from './ProductsList'



// WEBPACK FOOTER //
// ./src/Shop/components/index.js